





















import { useVModel } from '@vueuse/core';
import { computed, defineComponent, PropType, ref } from '@vue/composition-api';

import { ITariffRegion } from '@/models';

import { VAutocomplete } from 'vuetify/lib/components';
import { useFetchTariffRegions } from '@/composable/tariffs';

export default defineComponent({
  name: 'TariffRegionAutoCompletePicker',

  props: {
    value: [Array, Number, Object] as PropType<
      ITariffRegion | number | (ITariffRegion | number)[]
    >,

    errorMessages: {
      type: [String, Array] as PropType<string | string[]>
    },

    itemText: {
      type: String,
      default: 'name'
    }
  },

  setup(props, { emit }) {
    const tariffRegionVModel = useVModel(props, 'value', emit, {
      passive: true
    });

    const errorMessageList = computed(() => {
      let errorList: string[] = [];

      if (error.value) {
        errorList.push(error.value.message);
      }
      if (props.errorMessages) {
        if (Array.isArray(props.errorMessages)) {
          errorList.push(...props.errorMessages);
        } else {
          errorList.push(props.errorMessages);
        }
      }

      return errorList;
    });

    const { error, tariffRegions, isLoading } = useFetchTariffRegions();

    // /** @public */
    const autocompleteRef = ref<
      InstanceType<typeof VAutocomplete> & { reset: () => void }
    >();

    /** @public */
    function reset() {
      if (autocompleteRef.value) autocompleteRef.value.reset();
    }

    return {
      reset,
      autocompleteRef,
      tariffRegions,
      tariffRegionVModel,
      isLoading,
      errorMessageList
    };
  }
});
